import ScanConfigurationsList from './ScanConfigurationsList.container';

export default ScanConfigurationsList;
